export const POSB_READY_EVENT = 'posb-ready';

export const name = 'rnBlue';
export default function rnBlue($q, $window) {
  'ngInject';

  const blueApiDeferred = $q.defer();

  const service = {
    getBlueApi,
    getRegistryHost,
  };

  activate();
  return service;

  //////////////

  function activate() {
    let blueApi = _.get($window, 'printos.blue.ui', {});
    if (blueApi.readyState === 'complete') {
      blueApiDeferred.resolve(blueApi);
    } else {
      // Intentionally use window instead of $window here since this is in activation,
      // which is causing any tests that mock up window to fail.
      window.addEventListener(POSB_READY_EVENT, () => {
        blueApiDeferred.resolve(_.get($window, '$printos'));
      });
    }
  }

  function getBlueApi() {
    return blueApiDeferred.promise;
  }

  /**
   * @returns {String} the PrintOS registry host, if configured for blue
   */
  function getRegistryHost() {
    return _.get($window, 'printos.blue.ui.registry.host');
  }
}
